"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadGranteeOptionsPromise = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../utils");
var shareDialogMappers_1 = require("../../shareDialogMappers");
var sdk_model_1 = require("@gooddata/sdk-model");
var createErrorOption = function (intl) {
    return [
        {
            isDisabled: true,
            type: "error",
            label: intl.formatMessage({
                id: "shareDialog.share.grantee.add.search.error.message",
            }),
        },
    ];
};
var matchAllGroupQueryString = function (query, allGroupLabel) {
    return allGroupLabel.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1;
};
/**
 * @internal
 */
exports.loadGranteeOptionsPromise = function (currentUser, sharedObjectRef, appliedGrantees, backend, workspace, intl, onGranteesLoaded) {
    return function (inputValue) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var availableGrantees, mappedUsers, mappedGroups, allGroupLabel, supportsEveryoneUserGroupForAccessControl, groupAllOption, _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, backend
                            .workspace(workspace)
                            .accessControl()
                            .getAvailableGrantees(sharedObjectRef, inputValue)];
                case 1:
                    availableGrantees = _b.sent();
                    mappedUsers = availableGrantees
                        .filter(sdk_model_1.isAvailableUserAccessGrantee)
                        .map(function (availableGrantee) { return shareDialogMappers_1.mapWorkspaceUserToGrantee(availableGrantee, currentUser); })
                        .sort(utils_1.sortGranteesByName(intl))
                        .map(function (user) {
                        return {
                            label: utils_1.getGranteeLabel(user, intl),
                            value: user,
                        };
                    });
                    mappedGroups = availableGrantees
                        .filter(sdk_model_1.isAvailableUserGroupAccessGrantee)
                        .map(function (availableGrantee) { return shareDialogMappers_1.mapWorkspaceUserGroupToGrantee(availableGrantee); })
                        .sort(utils_1.sortGranteesByName(intl))
                        .map(function (group) {
                        return {
                            label: utils_1.getGranteeLabel(group, intl),
                            value: group,
                        };
                    });
                    allGroupLabel = utils_1.getGranteeLabel(utils_1.GranteeGroupAll, intl);
                    supportsEveryoneUserGroupForAccessControl = backend.capabilities.supportsEveryoneUserGroupForAccessControl;
                    if (!utils_1.hasGroupAll(appliedGrantees) &&
                        matchAllGroupQueryString(inputValue, allGroupLabel) &&
                        supportsEveryoneUserGroupForAccessControl) {
                        groupAllOption = {
                            label: allGroupLabel,
                            value: utils_1.GranteeGroupAll,
                        };
                        mappedGroups = tslib_1.__spread([groupAllOption], mappedGroups);
                    }
                    onGranteesLoaded(tslib_1.__spread(mappedUsers, mappedGroups).length);
                    return [2 /*return*/, [
                            {
                                label: intl.formatMessage({ id: "shareDialog.share.grantee.add.label.group" }),
                                options: mappedGroups,
                            },
                            {
                                label: intl.formatMessage({ id: "shareDialog.share.grantee.add.label.user" }),
                                options: mappedUsers,
                            },
                        ]];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, createErrorOption(intl)];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
//# sourceMappingURL=loadGranteeOptionsPromise.js.map